$status = $(".o-single-product__sliders__paging-info");
$productDetailMobileCarousel = $(".product__media-list");
$productDetailMobileCarousel.on(
  "init reInit afterChange",
  function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide || 0) + 1,
      first = i;
    first < 10 && (first = "0" + i);
    var second = slick.slideCount;
    second < 10 && (second = "0" + second), $status.text(first + "/" + second);
  }
);
$(".product__media-list").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: !1,
  dots: !0,
  appendDots: ".o-single-product__vendor",
  infinite: !0,
  mobileFirst: !0,
  centerMode: !0,
  centerPadding: "20px",
  responsive: [
    {
      breakpoint: 768,
      settings: "unslick",
    },
  ],
});
$(window).resize(function () {
  $(window).width() < 768 && $(".product__media-list").slick("refresh");
});
$(window).on("scroll", function () {
  if (
    $(window).width() >= 768 &&
    !$(".productSliderWrapper").hasClass("scrolling")
  ) {
    let currentScroll = $(this).scrollTop();
    let selectedSlideIndex = 0;
    for (let i = 0; i < $(".product__media-list>li").length; i++) {
      let mainImage = $(".product__media-list>li:nth-child(" + (i + 1) + ")");
      let currentImageScroll = mainImage.offset().top;
      let currentImageHeight = mainImage.height();
      if (currentScroll >= currentImageScroll - currentImageHeight * 0.3) {
        selectedSlideIndex = i;
      }
    }
    if (
      !$(
        ".productSliderThumbnail:nth-child(" + (selectedSlideIndex + 1) + ")"
      ).hasClass("selected")
    ) {
      $(".productSliderThumbnail").removeClass("selected");
      $(
        ".productSliderThumbnail:nth-child(" + (selectedSlideIndex + 1) + ")"
      ).addClass("selected");
    }
    console.log(selectedSlideIndex);
  }
});

$(".productSliderThumbnail").on("click", function () {
  if (!$(this).hasClass("selected")) {
    let theIndex = Number($(this).attr("data-index"));
    $(".productSliderThumbnail").removeClass("selected");
    $(this).addClass("selected");
    $(".productSliderWrapper").addClass("scrolling");
    $([document.documentElement, document.body]).animate(
      {
        scrollTop:
          $(".product__media-list>li:nth-child(" + theIndex + ")").offset()
            .top - 90,
      },
      1000,
      function () {
        $(".productSliderWrapper").removeClass("scrolling");
      }
    );
  }
});
